import { memo } from 'react';
import { Box } from '@chakra-ui/react';

/**
 * 整列ボタン押下時にのみ動的生成される、兄弟ノードを囲む視覚的な枠。
 * 既存画面（Equipment.tsx/ProductionProcess.tsx）のGroupNode.tsxと見た目を揃えるため、
 * reactflow標準CSS（.react-flow__node-group）に依存せず直接スタイルを指定する。
 * propsを持たないため、親の無関係な再レンダー（AlertDialog開閉等）では常に再描画をスキップできる。
 */
export const BomCreateGroupNode = memo(function BomCreateGroupNode() {
  return (
    <Box
      w="100%"
      h="100%"
      border="1px dashed #999"
      borderRadius="md"
      bg="rgba(150,150,150,0.25)"
    />
  );
});
